module.exports = __webpack_public_path__ + "img/user-profile.2ac20142.svg";